import {
  HorizAlignment,
  ISearch,
  ISearchProfile,
  ISearchProvider,
  SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var SpendAllocationRuleSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_SPENDRL_ID',
        id_ui: 'SPEND_RULE_ID',
        name:  'SPEND_RULE_NAME'},


    searchProviderFields: {
        WB_SPENDRL_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
        SPEND_RULE_ID:      {type: SearchProviderFieldType.string, renderOptions: { columnName: 'ID', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
        SPEND_RULE_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
        CREATED_DTTS:   {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Created DtTs', columnResourceName: 'colCreatedDtTs', alignment: HorizAlignment.Left}, domainOptions: {}},
        MODIFIED_DTTS:       {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Modified DtTs', columnResourceName: 'colModifiedDtTs', alignment: HorizAlignment.Left}, domainOptions: {}},
    },

    search(searchOptions: ISearchRequest): Promise<any[]> {
        console.log(searchOptions);
        var findRequest = searchOptions || {}
        findRequest.model = 'vUI_SpendAllocationRule_Search'
        findRequest.fields = this.searchProviderFields
        //findRequest.where = {'USER_ID': 1};
        return PASearch.findByRequest(findRequest)
    }

}


var SpendAllocationRuleSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "SpendAllocationRuleSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'SPEND_RULE_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'SPEND_RULE_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'SPEND_RULE_NAME','SPEND_RULE_ID', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: SpendAllocationRuleSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var SpendAllocationRuleSearch: ISearch = {
    searchName: "Find SpendAllocationRule",
    renderOptions: { ui5ResourceId: "SpendAllocationRuleSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SpendAllocationRuleSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("SpendAllocationRuleBO", "SpendAllocationRule", SpendAllocationRuleSearch, "Spend Allocation Rule Search")

export {SpendAllocationRuleSearch}